/**
 * Keep secondary hits at the end of a combined result list so they cannot
 * outrank primary hits in mixed "All" search.
 */
export function appendLowRankHits<T>(primary: T[], secondary: T[], totalLimit: number, maxSecondary: number): T[] {
  const secondaryHits = secondary.slice(0, Math.max(0, maxSecondary));
  const primaryLimit = Math.max(0, totalLimit - secondaryHits.length);
  return [...primary.slice(0, primaryLimit), ...secondaryHits];
}
